import {
  SET_METRICS_PROPERTIES,
  SET_METRICS_PARAMS,
  SET_METRICS_READY,
  SEND_PAGEVIEW,
  SEND_CUSTOM_EVENT,
  RESET_USER_METRICS,
} from '../actions/metricsActions';

const initialState = {
  ready: false,
  receivedProps: false,
  data: {},
  metrics: {},
  params: '',
  event: null,
  dontFilter: false,
};

export default function MetricsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_METRICS_PROPERTIES:
      return { ...state, metrics: action.metrics, receivedProps: action.receivedProps };
    case SET_METRICS_PARAMS:
      return { ...state, params: action.params };
    case SET_METRICS_READY:
      return { ...state, ready: action.ready, receivedProps: (window.self !== window.top) ? state.receivedProps : true };
    case SEND_PAGEVIEW:
      return { ...state, data: action.data };
    case SEND_CUSTOM_EVENT:
      return {
        ...state, event: action.event, data: action.data, dontFilter: action.dontFilter
      };
    case RESET_USER_METRICS:
      return { ...state, data: action.data };
    default:
      return state;
  }
}
